import axios from "../util/axiosConfig";

import { getErrorMessage } from "../util/ErrorUtils";

export const fetchOrganisationsAPI = async (payload) => {
  return await axios
    .post(`/api/v1/fetch-organisations`, payload)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};

export const updateOrganisationAPI = async (payload) => {
  return await axios
    .post(`/api/v1/add-update-organisation`, payload)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
};

export const getOrganisationsServicesAPI = async () => {
  return await axios
    .get(`/api/v1/healthsystems/org/participants?mipId=150`)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessage(error) };
    });
}